
/**
 *  echarts tooltip 自动轮播
 *  @author liuwei
 *  @param myChart  //初始化echarts的实例
 *  @param option   //指定图表的配置项和数据
 *  @param num      //类目数量(原因：循环时达到最大值后，使其从头开始循环)
 *  @param time     //轮播间隔时长
 */

 export function autoHover(myChart, option, num) {
   console.log(option)
  var time = 3000;
  if(!num){
    num = 0;
  }
  var count = 0;
  var timeTicket = null;
  timeTicket && clearInterval(timeTicket);
  timeTicket = setInterval(function () {
    //显示提示框

    myChart.dispatchAction({
      type: "showTip",
      seriesIndex:num -1 == count ? 2 : 1,
      dataIndex: num -1 == count ? 0 : count
    });
    console.log(count)
    count++;
    if (count >= num) {
      count = 0
    }
  }, time);
  myChart.on("mouseover", function (params) {
    clearInterval(timeTicket);
     //显示提示框
    console.log(params);
    myChart.dispatchAction({
      type: "showTip",
      seriesIndex: params.seriesIndex,
      dataIndex: params.dataIndex
    });
  });
  myChart.on("mouseout", function () {
    timeTicket && clearInterval(timeTicket);
    timeTicket = setInterval(function () {
      myChart.dispatchAction({
        type: "showTip",
        seriesIndex:num -1 == count ? 2 : 1,
        dataIndex: num -1 == count ? 0 : count
      });
      count++;
      if (count >= num) {
        count = 0
      }
    }, time);
  });
}
export default {
  autoHover
}



// WEBPACK FOOTER //
// ./src/components/charts/js/tools.js